import { createContext, useReducer } from "react";

export const FoodTextContext = createContext();

export const foodTextReducer = (state, action) => {
    switch (action.type) {
        case 'SET_FOOD_TEXT':
            return {
                foodText: action.payload
            }
        case 'CREATE_FOOD_TEXT':
            return {
                foodText: [action.payload, ...state.foodText]
            }
        case 'DELETE_FOOD_TEXT':
            return {
                foodText: state.foodText.filter(a => a._id !== action.payload._id)
            }
        default:
            return state
    };
};

export const FoodTextContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(foodTextReducer, {
        foodText: null
    });

    return (
        <FoodTextContext.Provider value={{ ...state, dispatch }}>
            {children}
        </FoodTextContext.Provider>
    );
};